import { defaultCtx } from "~/lib/AjaxCtx"
import { buildListQueryString } from "~/modules/list/utils"

export default class ListService {
    constructor(ctx) {
        this.$http = ctx ?? defaultCtx
    }

    async fetchParent(parents) {
        const parent = parents[parents.length - 1]
        const grandparent = parents[parents.length - 2]

        let url = ""
        switch (parent.type) {
            case "area":
                url = `/discover-areas/${parent.id}`
                break

            case "library":
                url = `/libraries/${parent.id}`
                break

            case "itinerary":
                url = `/itineraries/${parent.id}`
                break

            case "school":
                if (grandparent?.type === "itinerary") {
                    url = `/itineraries/${grandparent.id}/learn-schools/${parent.id}`
                } else {
                    url = `/learn-schools/${parent.id}`
                }
                break

            case "CatalogItinerary":
                url = `/discover-itineraries/${parent.id}`
                break

            case "CatalogSchool":
                if (grandparent?.type === "CatalogItinerary") {
                    url = `/discover-itineraries/${grandparent.id}/discover-schools/${parent.id}`
                } else {
                    url = `/discover-schools/${parent.id}`
                }
                break

            default:
                throw new Error(
                    `Don't know how to get parent info for ${parent.type}`
                )
        }

        return await this.$http.fetchData(url)
    }

    async fetchItems({ description, instance, parents, more }) {
        const queryString = buildListQueryString({
            description,
            instance,
            parents,
            more,
        })

        let [url, qs] = description.url.split("?")
        qs = [qs, queryString].filter(v => !!v).join("&")
        if (qs) url += `?${qs}`

        const { data: items, meta = {} } = await this.$http.fetchAPI(url)
        const { filters, orders, totalCount, ...rest } = meta
        const nextCursor = meta.cursor?.next
        return { items, filters, orders, totalCount, nextCursor, rest }
    }
}
